<template>
	<div :class="[width, height]">
		<div class="content-loader-animate h-full rounded" />
	</div>
</template>

<script setup>
defineProps({
	width: {
		type: String,
		required: false,
	},
	height: {
		type: String,
		required: false,
	},
})
</script>
